import { COUPON_COURSE_PACKAGE } from '../constants'

export default function course(state = {
  couponCoursePackages: null, // 套餐优惠券对应的套餐信息
}, action) {
  switch (action.type) {
    case COUPON_COURSE_PACKAGE:
      return Object.assign({}, state, {
        couponCoursePackages: action.couponCoursePackages,
      })
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/course.js